import React from "react";
import { Col, Collapse, Row } from "antd";
const { Panel } = Collapse;
import { AccordionNavComponentTypes } from "./AccordionNavComponent.types";
import "./AccordionNavComponent.scss";
import { UpOutlined } from "@ant-design/icons";


const AccordionNavComponent = ({ AvailableContent }: AccordionNavComponentTypes) => {
   return (
    <div className="AccordionNavComponent">
      <Collapse
        accordion
        expandIconPosition={"end"}
        className={"bg-white"}
        expandIcon={({ isActive }) => (
          <UpOutlined
            style={{ color: `${isActive ? "#FF4E04" : "#004CC6"}`}}
            rotate={isActive ? 360 : 180}
          />
        )}
      >
        {AvailableContent.map((item, index) => (
          <Panel
            className={""}
            key={`option-${item.slug}`}
            header={
              <Row style={{height:'40px', display:'flex', alignItems:'center'}} >
                <Col xs={15} offset={0} className={"headerLabel"}  >
                  {item.title}
                </Col>
              </Row>
            }
          >
            <div className="">
              {item.content}
            </div>
          </Panel>
        ))}
      </Collapse>
    </div>
  );
};

export default AccordionNavComponent;
